import { render } from "./UserChats.vue?vue&type=template&id=37f75e56"
import script from "./UserChats.vue?vue&type=script&lang=js"
export * from "./UserChats.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/medicalmobile-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__